import { ReactElement, useEffect, useState } from 'react';

import { BannerImage } from '../components/BannerImage';
import { HirePlanFormSection } from '../components/HirePlanForm/ServidorGDFPaP/HirePlanFormSection';
import { HirePlanMobileArticleHeader } from '../components/HirePlanForm/mobile/HirePlanMobileArticleHeader';
import { PurchaseSummary } from '../components/HirePlanForm/PurchaseSummaryGdf';
import { PageHelmet } from '../components/PageHelmet';
import { useWindowSizeStore } from '../stores/useWindowSizeStore';
import { useRouteLoaderData } from 'react-router-dom';
import { useBoostedPlanDataStore } from '../stores/useBoostedPlanDataStore';
import { useNortheastPlanDataStore } from '../stores/useNortheastPlanDataStore';

export function HirePlanGDFPagePaP(): ReactElement {
  const GDFPlanData: any = useRouteLoaderData('token-servidorPaP');

  const initialPlanData = GDFPlanData;
  const boostedPlanData = useBoostedPlanDataStore(state => state.data);
  const northeastPlanData = useNortheastPlanDataStore(state => state.data);
  const width = useWindowSizeStore(state => state.width);

  const [data, setData] = useState(initialPlanData);

  useEffect(() => {
    if (Object.keys(boostedPlanData).length !== 0 && boostedPlanData != data) {
      setData(boostedPlanData);
    } else if (
      Object.keys(northeastPlanData).length !== 0 &&
      northeastPlanData != data
    ) {
      setData(northeastPlanData);
    }
  }, [boostedPlanData, northeastPlanData]);

  const hirePlanGDFSections =
    width >= 1086
      ? [
          <HirePlanFormSection key="hirePlanFormSection" />,
          <PurchaseSummary key="purchaseSummary" />,
        ]
      : [
          <PurchaseSummary key="purchaseSummary" />,
          <HirePlanFormSection key="hirePlanFormSection" />,
        ];

  return (
    <div className="overflow-hidden">
      <PageHelmet title="Contratar Plano | OdontoGroup" />

      <BannerImage page="plan" imgSource="/assets/images/plan-banner.jpg" />
      <div className="">
        <article className="-mb-20 bg-transparent min-[748px]:-mt-[326px] -mt-[57px] max-w-[1551px] max-[1599px]:px-6 mx-auto">
          <div className="flex 2xl:gap-16 min-[748px]:gap-8 gap-16 max-[1085px]:flex-col">
            <HirePlanMobileArticleHeader />
            {hirePlanGDFSections}
          </div>
        </article>
      </div>
    </div>
  );
}
